/**
 * The Web Share API rejects with an `AbortError` when the visitor closes the native
 * share sheet without picking a target. That is normal user behaviour, not a failure.
 *
 * Every other rejection (for example `NotAllowedError` from a missing user gesture)
 * is a genuine sharing failure and must keep reporting.
 */
export function isShareDismissedByUser(error: unknown) {
  return error instanceof Error && error.name === 'AbortError';
}
